import { initBotId } from "botid/client/core";

initBotId({
  protect: [
    {
      path: "/api/user/profile-signup",
      method: "POST",
      advancedOptions: {
        checkLevel: "deepAnalysis",
      },
    },
  ],
});